import { render } from "./ReportTable.vue?vue&type=template&id=6866946c&scoped=true"
import script from "./ReportTable.vue?vue&type=script&lang=js"
export * from "./ReportTable.vue?vue&type=script&lang=js"

import "./ReportTable.vue?vue&type=style&index=0&id=6866946c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6866946c"]])

export default __exports__